import dayjs from 'dayjs'
import 'dayjs/locale/id'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import id from './locales/id.json'

const STORAGE_KEY = 'marina:locale'

const initialLang = (() => {
  try {
    return localStorage.getItem(STORAGE_KEY) ?? 'en'
  } catch {
    return 'en'
  }
})()

i18n.use(initReactI18next).init({
  resources: {
    id: { translation: id },
    en: { translation: en },
  },
  lng: initialLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

dayjs.locale(initialLang === 'id' ? 'id' : 'en')

i18n.on('languageChanged', (lng) => {
  dayjs.locale(lng === 'id' ? 'id' : 'en')
})

export function setLocale(locale: 'id' | 'en') {
  i18n.changeLanguage(locale)
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {}
}

export function getLocale(): 'id' | 'en' {
  return (i18n.language as 'id' | 'en') ?? 'id'
}

export default i18n
